<app-error-message header="There was a problem logging you in."
                   [subHeader]="subHeader"></app-error-message>

<ng-template #subHeader>
  <p>
    {{ errorMessage }}
  </p>

  <p>
    Please try again later. If the problem persists, please contact GAC <a class="underline"
       href="mailto: help@gac.com">support</a>.
  </p>
</ng-template>